import type { StyleRule } from '@archipro-design/aria';

export const Divider: StyleRule = () => ({
    borderStyle: 'none none solid none',
    borderBottom: `1px solid #D2D2D0`,
    margin: 0,
});
